import { commonDataLoaderFactories } from 'src/app/dashboards/common/data-loaders/common-dataloaders';
import { Injectable } from '@angular/core';
import { IFactory } from 'src/app/utils/IFactory';
import { IDataLoader } from './IDataLoader';
import { LoggerService } from '../logger/logger.service';

export const DataLoaderFactories = {
    ...commonDataLoaderFactories,
};

@Injectable({
    providedIn: 'root',
})
/**
 * Service responsible for managing data loader instances.
 * It maintains a registry of data loader factories and ensures that only one instance of each data loader is created.
 */
export class DataLoaderService {
    /**
     * Stores registry of factories for data loaders. Only factories are stored, not real objects.
     */
    private dataLoaders: Record<string, IDataLoader> = {};

    /**
     * Initializes a new instance of the DataLoaderService class.
     * Logs a message indicating that the service has been created.
     */
    constructor(logger: LoggerService) {
        logger.debug('DataLoaderService created.');
        // TODO: Verify if each key from Ids exists in Factories
    }

    /**
     * Resets the registry of data loaders, clearing all stored instances.
     */
    public resetRegistry() {
        this.dataLoaders = {};
    }

    /**
     * Retrieves an existing data loader instance or creates a new one using the provided factory.
     * @param factory - The factory used to create a new data loader instance if it does not already exist.
     * @returns The existing or newly created data loader instance.
     */
    public getOrCreateWithFactory(factory: IFactory<IDataLoader>) {
        const instanceId = factory.createdInstanceId;

        if (instanceId in this.dataLoaders) {
            return this.dataLoaders[instanceId]!;
        } else {
            this.dataLoaders[instanceId] = factory.create();
            return this.dataLoaders[instanceId]!;
        }
    }

    // Additional methods commented out for future implementation
    // public getDataLoader(id: DataLoaderFactoryId, options: any): DataLoader { ... }
    // subscribe(id: DataLoaderId, subscriber: (data: string) => void) { ... }    
    
    // public getDataLoader(
    //     id: DataLoaderFactoryId,
    //     options: any
    // ): DataLoader {
    //     if (id in this.dataLoaders) {
    //         return this.dataLoaders[id]!;
    //     } else {
    //         this.dataLoaders[id] = DataLoaderFactories[id](options).create();
    //         return this.dataLoaders[id]!;
    //     }
    // }

    // subscribe(id: DataLoaderId, subscriber: (data: string) => void) {
    //     if (id in this.dataLoaders) {
    //         this.dataLoaders[id]!.emitter.subscribe(subscriber);
    //     } else {
    //         throw new Error(
    //             `[DataLoaderService] id '${id}' not found inside this.dataLoaders`
    //         );
    //     }
    // }
}
